export const crudConfig = {
    endpoint: 'permission-objects',
    primaryKey: 'className',
    functions: {
        fetchAll: {
            method: 'get',
            returnType: 'Array',
            service: 'core',
            args: [],
            query: {
                property: 'queryClass=FindAll'
            }
        }
    }
};

export default crudConfig;
